import { render, staticRenderFns } from "./SectorDropdown.vue?vue&type=template&id=19014a1f&"
import script from "./SectorDropdown.vue?vue&type=script&lang=js&"
export * from "./SectorDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports